import { render, staticRenderFns } from "./ControllerTop.vue?vue&type=template&id=65c5f1a2&"
import script from "./ControllerTop.vue?vue&type=script&lang=js&"
export * from "./ControllerTop.vue?vue&type=script&lang=js&"
import style0 from "./ControllerTop.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports